import { render, staticRenderFns } from "./FamPicker.vue?vue&type=template&id=1410bd7d&scoped=true&lang=pug"
import script from "./FamPicker.vue?vue&type=script&lang=js"
export * from "./FamPicker.vue?vue&type=script&lang=js"
import style0 from "./FamPicker.vue?vue&type=style&index=0&id=1410bd7d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410bd7d",
  null
  
)

export default component.exports